<div class="container-fluid p-3 mobile-p0">
  <div class="row" style="width: 600px; margin: 0 auto">
    <div class="w-100">
      <div id="email-editor" [innerHTML]="HTMLTemplate.innerHTML | sanitizeHtml: 'html'">
      </div>
    </div>
  </div>
</div>

<ng-template #variablePickerModal let-modal>
  <app-iframe-modal-shell [src]="variablePickerUrl()" (close)="modal.dismiss('cancel')"></app-iframe-modal-shell>
</ng-template>
